<template>
<div>
      <v-text-field

        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        class='ma-3'
        no-data-text='No new task'
        hide-details
      ></v-text-field>
    <v-data-table
    :search="search"
    :loading="notificationLoading"
    :headers="headers"
    :items="queueMessage"
    item-key="name"
    class="elevation-1"
  >
     <template v-slot:item.userEmail="{ item }">
           <a @click='$router.push("/user/email/"+item.userEmail)'>{{item.userEmail}}</a>
          </template>
  <template v-slot:item.content="{ item }">
   
   
    <a v-if='item.type === "Health history update" || item.type === "Family history update"' @click='modal=true; formatContent(item.content,item)'>click to see details</a>
     <span v-else>{{item.content}}</span>
    </template>

     <template v-slot:item.action="{ item }">
        <v-icon
        title='mark as read'
        color='green'
        class="mr-2"
       @click='closeTask(item)'
      >
        check
      </v-icon>
    </template>

  </v-data-table>

       <v-dialog
      v-model="modal"
      
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline mb-5">
          Updated Content
        </v-card-title>
        <v-card-text>
           <v-data-table
          :headers="UpdateContentheaders"
          :items="updateContentItem"
          class="elevation-1"
        >
    <template v-slot:item.kind="{ item }">
      <span v-if='item.kind === "A"'>{{formatObjChange(item)}}</span>
      <span v-else>{{formatObjChange(item)}}</span>
    </template>

    <template v-slot:item.path="{ item }">
    <span>{{formatField(item.path)}}</span>
    </template>
        </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="modal = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { postReq} from '../../helper/firestore'
export default {
 
      watch: { 

      },
    props : {
      notificationLoading : Boolean,
              queueMessage : Array,
              headers: Array,
    },
  data () {
    return {
        search: null,
              UpdateContentheaders : [
      { text: 'Action', value: 'kind' },
      { text: 'Field', value: 'path' },
      ],
        modal : false,
        selectedObj : [],
        updateContentItem : null,
       
     

    }
  },
    computed: {
    ...mapFields([
      'user',
    ]),
  },
  methods : {
      
    formatField(pathArr){
      if(Number.isInteger(pathArr[0])){
         pathArr[0] = this.selectedObj[pathArr[0]].name
      }
      return pathArr
    },
    closeTask(item){
      postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/updateTaskStatus', { idToken: this.user.idToken, taskId: item.id, requestType: "closed"}, result => {
            if (result.status !== 200) { return }
        this.$emit("getUserTask");
        })
    },
          getUserTasks(){
      this.notificationLoading = true;
          postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/getmytasks', { gcid:this.user.uid,requestType:'open'}, result => { 
            if (result.status !== 200) { this.notificationLoading = false; return }

            this.queueMessage = result.data;
            this.notificationLoading = false;
    })
    },


          formatObjChange(item){
      
         if(item.kind === "A"){
        switch (item.item.kind){
          case "N":
            return "Added";
          case "D":
            return "Deleted";
          case "E":
            return "Edited";
        }
      }
     else{
        switch (item.kind){
          case "N":
            return "Added";
          case "D":
            return "Deleted";
          case "E":
            return "Edited";
        }
     }
    },
       formatContent(content,item){
      this.updateContentItem = JSON.parse(content);
      if(item.obj) {
        this.selectedObj = item.obj
      }
      

    },
  }
}
</script>

<style>

</style>